module.exports = __webpack_public_path__ + "img/logo-default.96880872.svg";